import { IS_FAVORITE_APP } from "../../config/constant";

const leadReducer = (state='',action)=>{
    switch(action.type){
        case "ADD_LEAD_INFO": 
            //let navTab = NavDetail; 
            //let activeNum = (action.payload.details && action.payload.details.active_tab !='') ? (IS_FAVORITE_APP && [null,'1'].includes(action.payload.details.active_tab)) ? 2 : action.payload.details.active_tab:1 
            //let lead_source = (action.payload.details && action.payload.details.lead_source) ? action.payload.details.lead_source : 'finance'
            // if(['refinance','bikerefinance'].includes(lead_source) && +activeNum === 3) navTab.car = true;
            // else if(+activeNum === 7) navTab.payment = true;
            // else if(+activeNum === 6) navTab.fid = true;
            //  else if(+activeNum === 8) navTab.edited_loan = true;
            // else navTab[Object.keys(navTab)[activeNum-1]] = true; 
            
            const details = action.payload.details || {};
            const lead_source = details.lead_source || "finance";
            let activeTab = details.active_page;
            if (!activeTab) {
                activeTab = (IS_FAVORITE_APP || lead_source === 'hrf') ? "customer" : "dealer";
            }
            return  {
                ...state, 
                leadDetail:action.payload,
                activePage: (action.payload.details) ? (IS_FAVORITE_APP && [null,'1'].includes(action.payload.details.active_tab)) ? 2 : action.payload.details.active_tab:1, 
                detailPage:activeTab
            }  

        case "DETAIL_PAGE":
			return {
				...state,
				detailPage: action.payload,
			}; 

		case "UPDATE_LEAD_DETAIL":
			return {
				...state,
				leadDetail: action.payload,
			};   

		case "UPDATE_ACTIVE_PAGE":
            return {
				...state,
				activePage: action.payload,
			};
        
        case "UPDATE_LEAD_INFO":  
            return  {
                ...state, 
                leadDetail:action.payload
            }      
             
        case "SET_PAYMENT_FILTER":
            if (!action.activeTab) {
                return {
                    ...state,
                    paymentFilters: {
                        finance: [],
                        refinance: [],
                    }
                }
            }
            return  {
                ...state, 
                paymentFilters: {
                    ...state.paymentFilters,
                    [action.activeTab]: action.payload
                }
            }
        case "UPDATE_RADIO_CHECK":  
            return  {
                ...state, 
                radio_check:action.payload
            }       
        default:
            return state    
    }
}

export default leadReducer;
